import request from '@/utils/request';
import * as types from '@/api/release/types';
import { reqCatch, reqCatchV2, type catchRt } from '@/utils/catch';
import type { CommonWithPageReqType } from '@/utils/types';

export function createRelease(data: types.createReleaseReqType): Promise<types.createReleaseReqType> {
  return request({
    url: `/api/v2/projects/${data.repoId}/releases`,
    method: 'post',
    data
  });
}

export function getReleases(params: types.getReleasesType): catchRt<CommonWithPageReqType<types.getReleaseResType[]>> {
  return reqCatchV2(() => request({
    url: `/api/v2/projects/${params.repoId}/releases`,
    method: 'get',
    params
  }));
}
export function getReleaseDetail(params: types.getReleaseDetailReqType): Promise<types.getReleaseDetailReqType> {
  return request({
    url: `/api/v2/projects/${params.repoId}/releases/${params.tag_name}`,
    method: 'get',
    params
  });
}

// 删除release
export function deleteRelease(data: types.commonReleaseResType): Promise<types.commonReleaseResType> {
  return request({
    url: `/api/v2/projects/${data.project_id}/releases/${data.tag_name}`,
    method: 'delete',
    data
  });
}

// 编辑更新release
export function updateRelease(data: types.commonReleaseResType): Promise<types.commonReleaseResType> {
  const { repoId, params, inCodeTag_name } = data;
  return request({
    url: `/api/v2/projects/${repoId}/releases/${inCodeTag_name}`,
    method: 'put',
    data: params
  });
}

// 编辑更新release
export function statusCancel(attachment_id: string): Promise<types.commonReleaseResType> {
  return reqCatch(() => request({
    url: `/api/v2/projects/user_attachment/${attachment_id}/status/cancel`,
    method: 'put'
  }));
}

// 获取release上传文件地址
export function getReleaseUploadUrl(project_id: string | number, data: object): Promise<any> {
  return reqCatchV2(() => request({
    url: `/api/v2/projects/${project_id}/releases/upload`,
    method: 'post',
    data
  }));
};

// 获取release上传文件地址
export function putReleaseUploadUrl(url: string | number, headers: object, params:object): Promise<any> {
  return reqCatchV2(() => request({
    url,
    method: 'put',
    body: params,
    headers
  }));
};

/**
 * 上传文件
 */
export function uploadFileWithProgress(
  /** 上传地址 */
  putUrl: string,
  currentFile: File,
  /** 设置的请求头数据 */
  headers: { [k: string]: string; },
  /** 进度回调函数  */
  onProgress: Function
): Promise<{ status: number, error_code?: number, error_message?: string; }> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', putUrl, true);

    if (typeof headers === 'object') {
      for (const key in headers) {
        xhr.setRequestHeader(key, headers[key]);
      }
    }
    xhr.upload.onprogress = function (event) {
      if (event.lengthComputable && typeof onProgress === 'function') {
        // 进度事件处理
        let percentComplete = (event.loaded / event.total) * 100;
        percentComplete = Math.round(percentComplete);
        percentComplete = percentComplete > 1 ? percentComplete - 1 : 0; // 因为100% 的时候还会padding 显示成99%比较好
        onProgress(percentComplete, xhr, resolve);
      }
    };

    // 成功响应
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve({ status: xhr.status });
      } else {
        reject({ error_code: xhr.status, error_message: xhr.responseText });
      }
    };

    // 错误处理
    xhr.onerror = function () {
      reject({ error_code: xhr.status, error_message: 'File upload error' });
    };

    // 发送请求
    xhr.send(currentFile);
  });
}

